<template>
  <div>
    <van-empty description="暂无数据" v-if="lst.da.length==0" />
    <van-list :finished="lst.finish" @load="loadPage" v-model="lst.loading" style="padding: 10px 0px;">
      <div class="wcard" v-for="item in lst.da" :key="item.ID">
        <div class="bd">
          <van-row :gutter="8">
            <van-col :span="18">
              <p>{{ item.TITLE }} </p>
              <p style="font-size: 14px; color: #999">{{item.DESCRIPTION}}</p>
              <p v-if="item.STEP==91" style="color: red;font-size: 14px;">理由：{{item.REFUSE_DESC}}</p>
            </van-col>
            <van-col :span="6" style="padding: 10px 0px 0px 0px">
              <van-button type="info" icon="close" size="small" v-if="item.STEP<90" @click="cancel(item.ID)">撤消</van-button>
            </van-col>
          </van-row>
        </div>
        <div class="ft">
          <van-row>
            <van-col :span="8">{{item.CONF_NAME}}</van-col>
            <van-col :span="8">{{item.CREATED_DT|datetime('YYYY-MM-DD')}}</van-col>
            <van-col :span="8" style="color:#3aa8ec">{{item.STEP_NAME}}</van-col>
          </van-row>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  data(){
    return{
      sea:{
        PAGE_SIZE:10,
        PAGE_INDEX:-1,
        CONF_SN:"",
        FOR:"SUB",
        KEY:"",
      },
      lst:{
        da:[],
        loading:false,
        finish:false
      },
    }
  },
  created() {
  },
  methods:{
    filter(){
      this.lst.da.length=0;
      this.sea.PAGE_INDEX=0;
      this.getList();
    },
    loadPage(){
      this.sea.PAGE_INDEX+=1;
      this.getList();
    },
    getList(){
      let self=this;
      this.whale.remote.getCollection({
        url:"/api/Mobile/WFL/ActApi/GetList",
        data:this.sea,
        completed(its,n){
          self.lst.da.push(...its.ITEMS);
          self.lst.loading=false;
          if (self.lst.da.length>=n) self.lst.finish=true;
        }
      })
    },
    cancel(id) {
      let self=this;
      this.whale.remote.getResult({
        url:"/api/Mobile/WFL/ActApi/Cancel",
        data: {ID:id},
        completed:function (){
          self.$dialog.alert({
            title:"完成",
            message:"申请已撤消！",
            theme:"round",
          }).then(()=>{self.filter();})
        }
      })
    }
  }
}
</script>
<style scoped>
.wcard {margin: 0 12px 12px; overflow: hidden; background-color: #fff; border-radius: 8px; box-shadow: 0 0 4px rgba(0,0,0,.1)}
.wcard .ft {border-top: 1px dashed #ebedf0; padding: 8px 16px; font-size: 12px; min-height: 20px}
.wcard .bd { padding-left: 10px;}
.wcard .bd .lf {text-align: center; color:#ee0a24; padding-top: 10px}
.wcard .bd .lf h2 {font-size: 30px; font-weight: 500; display:inline;}
.wcard .bd .lf span {font-size: 40%; font-weight: normal; margin-left: 2px}
.wcard .bd .lf p {font-size: 14px; line-height: 16px}
</style>